<template>
  <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <v-btn icon @click="$emit('sheetClose')">
          <Close/>
        </v-btn>
      </v-card-title>
      <v-card-text class="border-none pt-0">
        <figure class="badge-info">
          <Badge :info="item" hide-title />
          <figcaption class="badge-info-caption">
            <b class="tit">{{ item.name }}</b>
            <p class="txt" v-html="item.dscrt"></p>
          </figcaption>
        </figure>
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import Close from '@/components/icons/Close'
import Badge from '@/components/icons/Badge'

export default {
  components: {
    Close,
    Badge
  },
  props: {
    sheet: Boolean,
    item: Object
  },
  data: () => ({}),
  computed: {},
  methods: {}
}
</script>

